export const GET_ORDERS_SUCCESS = 'GET_ORDERS_SUCCESS';
export const GET_MY_ORDERS = 'GET_MY_ORDERS';
export const GET_MY_ORDERS_SUCCESS = 'GET_MY_ORDERS_SUCCESS';
export const GET_MY_ORDERS_ERROR = 'GET_MY_ORDERS_ERROR';
export const PAGE_LOAD_ANALYTICS_ACTION = 'PAGE_LOAD_ANALYTICS_ACTION';
export const RETURNS_ANALYTICS_ACTION = 'RETURNS_ANALYTICS_ACTION';
